import React, { Component }          from 'react';
import Select                        from 'react-select'
import { ROLES }                     from '../../common/Common';

import icClose                       from '../../../img/ic_close.svg';

import "./Dialog.scss";

class SearchRecordings extends Component {

  constructor(props) {
    super(props);

    this.state            = {
      locationId: -1,
      email: '',
      name: '',
      startDate: new Date(),
      endDate: undefined,
    }
  }

  componentDidMount() {
    const today = new Date()
    const yesterday = new Date(today)
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    today.setDate(today.getDate() + 1);
    today.setHours(0, 0, 0, 0)
    yesterday.setDate(today.getDate() - 2);
    yesterday.setHours(0, 0, 0, 0)
    this.setState({startDate: this.formatDateString(yesterday), endDate: this.formatDateString(today)})
  }

  pad(n){
    return `${Math.floor(Math.abs(n))}`.padStart(2, '0');
  }


  formatDateString(date) {
    const year = date.getFullYear();
    const month = this.pad(date.getMonth() + 1); // Months are 0-indexed
    const day = this.pad(date.getDate());
    const hours = this.pad(date.getHours());
    const minutes = this.pad(date.getMinutes());
    const seconds = this.pad(date.getSeconds());
    const milliseconds = date.getMilliseconds().toString().padStart(3, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  onFieldChange(name, event) {
    let value = event.target.value;
    this.setState({[name]: value});
  }

  onMultiSelectChange(name, data) {
    this.setState({[name]: data});
  }

  getTitleText() {
    return 'Filter Recordings';
  }

  getExhibitOptions() {
    return [
      { value: 1, label: "Pittsburgh - Warhol1" },
      { value: 2, label: "Pittsburgh - Warhol2" },
      { value: 3, label: "Pittsburgh - Warhol3" },
    ];
  }

  isReadyToSubmit() {
    return this.state.locationId !== -1 ||
          (this.state.email && this.state.email.length > 0) ||
          (this.state.startDate && this.state.endDate)
  }

  search() {
    if (this.isReadyToSubmit()) {
      let filterObj = {};
      if (this.state.locationId >= 0) {
        filterObj['locationId'] = this.state.locationId;
      }
      if (this.state.email) {
        filterObj['email'] = this.state.email;
      }
      if (this.state.name) {
        filterObj['name'] = this.state.name;
      }
      if (this.state.startDate && this.state.endDate) {
        filterObj['startDate'] = this.state.startDate;
        filterObj['endDate'] = this.state.endDate;
      }
      this.props.filterResults(filterObj)
    }
  }

  renderLocationOptions() {
    let itemsToRender = this.props.locations ? this.props.locations : [];
    return itemsToRender.map((location, i) => {
      return <option key={i} value={location.id}>{location.name}</option>
    })
  }

  render() {
    return (
      <div className={`edit-dialog ${this.props.show ? 'show' : ''}`}>
        <div className="content search">
          <div className="dialog-title">{this.getTitleText()}</div>
          <div className="fields">
            <div className="field">
              <div className="title">LOCATION</div>
              <select value={this.state.role} onChange={(event) => this.onFieldChange('locationId', event)}>
                <option default value={-1}>All Locations</option>
                {this.renderLocationOptions()}
              </select>
            </div>
            <div className="field">
              <div className="title">EMAIL (* as wildcards -- like *rek@gmail.com for derek@gmail.com)</div>
              <input onChange={(event) => this.onFieldChange('email', event)} value={this.state.email} type="text" />
            </div>
            <div className="field">
              <div className="title">NAME (* as wildcards -- like M*k* for Mike)</div>
              <input onChange={(event) => this.onFieldChange('name', event)} value={this.state.name} type="text" />
            </div>
            <div className="field multiple">
              <div className="subfield">
                <div className="title">START DATE</div>
                <input onChange={(event) => this.onFieldChange('startDate', event)} value={this.state.startDate} step="60" type="datetime-local" />
              </div>
              <div className="subfield">
                <div className="title">END DATE</div>
                <input onChange={(event) => this.onFieldChange('endDate', event)} value={this.state.endDate} step="60" type="datetime-local" />
              </div>
            </div>
          </div>
          <div className="bottom-buttons">
            <div onClick={this.search.bind(this)} className={`action-button ${this.isReadyToSubmit() ? '' : 'disable'}`}>UPDATE</div>
          </div>
          <img onClick={this.props.closeDialog.bind(this)} className="close" src={icClose}/>
        </div>
      </div>
    );
  }
}

export default SearchRecordings;